<template>
    <div class="p-2 row-gap row-gap-10-px">
        <div class="line">
            <div class="field-item">
                <div class="lable_item">統括部</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        id="internal-md"
                        type="number"
                        input-class="custom-border width-70-px"
                        v-model="data.internal.MDCD"
                        :maxLength="5"
                        :onChangeInput="(index, value) => $emit('refer-md', index, value, data.internal)"
                        :is-show-clear="false"
                        page-search="PopupMST005"
                        :data-extra="{ company_cd: user.company_cd }"
                        :auto-close="true"
                        :isReadonly="false"
                        @onReferValueName="(value) => $emit('get-md-name', value, data.internal)"
                        :isDisabled="!user.company_cd"
                        :isDisabledInput="!user.company_cd"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.internal.MDName"
                            id="MDName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">ユーザ</div>
                <div class="item-group input-search-area input-no-required">
                    <ans-input-search
                        id="EmployeeCD"
                        type="number"
                        input-class="custom-border width-70-px"
                        v-model="data.internal.EmployeeCD"
                        :maxLength="4"
                        :onChangeInput="(index, value) => $emit('refer-employee', index, value, data.internal)"
                        :is-show-clear="false"
                        page-search="PopupMST008"
                        :auto-close="true"
                        :isReadonly="false"
                        :data-extra="{ company_cd: user.company_cd, department_cd: data.internal.MDCD }"
                        :is-disabled="!data.internal.MDCD"
                        @onReferValueName="(value) => $emit('get-employee-name', value, data.internal)"
                    />
                    <div class="w-100">
                        <ans-input
                            input-class="span-input not_set overflow-dot border-none-dm"
                            v-model="data.internal.EmployeeName"
                            id="EmployeeName"
                            is-required
                            :maxLength="100"
                            :isDisabled="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">件名</div>
                <div class="item-group input-no-required">
                    <ans-input
                        id="internal-subject"
                        input-class="custom-border"
                        :maxLength="100"
                        v-model="data.internal.Subject"
                        is-enable-i-m-e
                        is-required
                    />
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item h-100">メッセージ</div>
                <div class="item-group">
                    <ans-input
                        id="internal-body"
                        type="textarea"
                        :rows="4"
                        input-class="custom-border"
                        :maxLength="100"
                        v-model="data.internal.Body"
                        is-required
                        is-enable-i-m-e
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'ComposeInternal',
    props: { errors: Array },
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
